import React, { useEffect, useMemo } from "react"
import { Divider, makeStyles, MenuItem } from "@material-ui/core"
import { useQueryGroups } from "../../data"
import { toId } from "../../utils"
import { OutlinedSelect } from "./OutlinedSelect"
import { useAuth } from "../../services"

const useStyles = makeStyles(() => ({
  root: {
    minWidth: 125,
  },
}))

const GroupOutlinedSelect = ({
  onDataLoaded,
  allLabel = "All areas of work",
  hasAll = true,
  usersGroupsOnly = false,
  disabled: disabledInput = false,
  ...rest
}) => {
  const { data, loading } = useQueryGroups()
  const {
    principal: { groups: usersGroups },
  } = useAuth()
  const classes = useStyles()

  useEffect(() => {
    if (onDataLoaded && data) onDataLoaded(data)
  }, [data, onDataLoaded])

  const groups = useMemo(
    () => data?.groups.filter((group) => !usersGroupsOnly || usersGroups.includes(toId(group))) || [],
    [data, usersGroupsOnly, usersGroups]
  )

  const disabled = disabledInput || loading || !data?.groups.length

  return (
    <OutlinedSelect label="Areas of work" native={false} value="all" classes={classes} disabled={disabled} {...rest}>
      {hasAll && <MenuItem value="all">{allLabel}</MenuItem>}
      {hasAll && <Divider />}
      {groups.map((group) => (
        <MenuItem key={toId(group)} value={toId(group)}>
          {group.name}
        </MenuItem>
      ))}
    </OutlinedSelect>
  )
}

export { GroupOutlinedSelect }
